import React from 'react'
import { useClientSideTranslation } from 'src/services/i18n'
import { useGetCurrentLanguage } from 'src/store/game'
import type { MarbleGame } from 'src/types/domain/Game'
import FlagCheckeredIcon from 'src/app/assets/icons/ico-flag-checkered.svg'
import { Button } from 'src/components/Button'

type Props = Readonly<{
  game: MarbleGame
  onShowPlaceBet: () => void
}>

export function NextRaceBetButton({ onShowPlaceBet }: Props) {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())

  return (
    <Button
      className="btn btn-next-race"
      onClick={onShowPlaceBet}
      type="button"
      useDefaultClasses={false}
    >
      <div className="inner">
        <FlagCheckeredIcon />
        <span>{t('Place bet on next game')}</span>
        <FlagCheckeredIcon />
      </div>
    </Button>
  )
}
